import React, { useState } from "react";
import { useSetState } from "react-use";

import StepFormRow from "../StepFormRow";
import { getUrlStatus, processLink } from "../../services/helpers";

import "./index.css";

function Form() {
  const [job, updateJob] = useSetState({
    link: "",
    campaign: "",
    access_token: process.env.REACT_APP_ACCESS_TOKEN,
  });

  const [urlStatus, setUrlStatus] = useState({
    valid: false,
    messages: [],
  });

  const [urlsIds, setUrlsIds] = useState([]);

  const updateUrl = (url) => {
    // const OriginalURL = urlsIds.find((id) => id === url.id);
    // if (OriginalURL) {
    //   Object.assign(OriginalURL, url);
    // }
  };

  const checkUrlIsValid = () => {
    return urlStatus.valid;
  };

  const handleChangeLink = (event) => {
    const processedLink = processLink(event.target.value);
    const status = getUrlStatus(processedLink);

    setUrlStatus(status);
    updateJob({ link: processedLink });
  };

  const handleChangeCampaign = (event) => {
    updateJob({ campaign: event.target.value });
  };

  const handleNewURL = () => {
    setUrlsIds([...urlsIds, urlsIds.length + 1]);
  };

  if (job.access_token === "") {
    return (
      <div>
        <h2>Erro! Sem token de acesso</h2>
        <p>Isso não deveria acontecer. Reporte para o time de Tech.</p>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid" style={{ marginTop: 20 }}>
        <div className="input-group input-group-sm mb-3">
          <label htmlFor="link-vaga" className="fullLabel">
            Link da Vaga
            <input
              className="form-control"
              name="link-vaga"
              value={job.link}
              onChange={handleChangeLink}
            ></input>
          </label>
          {!!urlStatus.messages.length && (
            <ul className="ul-messages">
              {urlStatus.messages.map((message) => (
                <li
                  className={
                    urlStatus.valid ? "valid ul-message" : "invalid ul-message"
                  }
                  key={message}
                >
                  {message}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="input-group input-group-sm">
          <label style={{ marginRight: 10 }} htmlFor="campaign">
            Campanha
            <input
              className="form-control form-control-sm"
              name="campaign"
              value={job.campaign}
              onChange={handleChangeCampaign}
            ></input>
          </label>
          <br />
          <ul className="list-group">
            {urlsIds.map((id) => (
              <StepFormRow
                key={id}
                id={id}
                job={job}
                checkUrl={checkUrlIsValid}
              ></StepFormRow>
            ))}
          </ul>
        </div>
        <div className="actions">
          <button className="btn btn-success add-button" onClick={handleNewURL}>
            Nova UTM
          </button>
        </div>
      </div>
    </>
  );
}

export default Form;
